import { z } from "zod/v4";
const ColorList = [
    "white",
    "lightGray",
    "gray",
    "brown",
    "orange",
    "yellow",
    "green",
    "blue",
    "purple",
    "pink",
    "red",
];
const ColorProperties = {
    white: {
        label: "白",
        background: "#FFFFFF",
        border: "#B3B7BA",
    },
    lightGray: {
        label: "ライトグレー",
        background: "#E4E2E2",
        border: "#656460",
    },
    gray: {
        label: "グレー",
        background: "#DCDBD8",
        border: "#656460",
    },
    brown: {
        label: "ブラウン",
        background: "#EAD8D2",
        border: "#8C5742",
    },
    orange: {
        label: "オレンジ",
        background: "#F7D6BE",
        border: "#B4612E",
    },
    yellow: {
        label: "黄",
        background: "#FCE9BC",
        border: "#BE7F24",
    },
    green: {
        label: "緑",
        background: "#D3E9D2",
        border: "#37714F",
    },
    blue: {
        label: "青",
        background: "#C9DEEB",
        border: "#296A98",
    },
    purple: {
        label: "紫",
        background: "#E2D5EA",
        border: "#7D4EA0",
    },
    pink: {
        label: "ピンク",
        background: "#F1D8E4",
        border: "#B13477",
    },
    red: {
        label: "赤",
        background: "#FEDAD5",
        border: "#C73538",
    },
};
const ColorSchema = z.enum(ColorList);
export const Color = {
    schema: ColorSchema,
    ...ColorProperties,
};
//# sourceMappingURL=color.js.map